export default function ({ res }) {
  return res.setHeader(
    'Expect-CT',
    'max-age=3600, report-uri="https://ct-report.example.com/reportOnly"'
  )
}
